import React from 'react'
import { Container } from 'app/sofia/scenes/NoMatch/styled'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/sofia/resources/constants'
import { Wrapper } from './styled'

export const NoResults = () => {
  const staticBlockID = CMS_BLOCK.PS_NO_RESULTS
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: true

  })

  return (
    <Container>
      {staticBlock.content && (
        <Wrapper
          dangerouslySetInnerHTML={{
            __html: staticBlock.content
          }}
        />
      )}
    </Container>
  )
}
